'use strict';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if ((from && typeof from === 'object') || typeof from === 'function') {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, '__esModule', { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  default: () => src_default,
});
module.exports = __toCommonJS(src_exports);
var import_react = require('react');
var getEventListenerName = () => {
  return 'visibilitychange';
};
var getIsVisible = () => {
  if (typeof document === 'undefined') {
    return true;
  }
  return !document.hidden;
};
var useTabVisibility = () => {
  const [visible, setVisible] = (0, import_react.useState)(getIsVisible());
  const handleVisibility = (0, import_react.useCallback)(() => setVisible(getIsVisible()), [setVisible]);
  (0, import_react.useEffect)(() => {
    const evListenerName = getEventListenerName();
    window == null ? void 0 : window.document.addEventListener(evListenerName, handleVisibility, false);
    return () => (window == null ? void 0 : window.document.removeEventListener(evListenerName, handleVisibility));
  }, [handleVisibility]);
  return (0, import_react.useMemo)(() => ({ visible }), [visible]);
};
var src_default = useTabVisibility;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
